import React from "react";

const Row = props => <tr class={`row-default`}>{props.children}</tr>;

export default Row;
